// /opt/isp_erp/frontend/src/pages/ONUAdministracion.jsx

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getOLTs } from '../api/olt.api';
import './ONUAdministracion.css';

export default function ONUAdministracion() {
  const [olts, setOlts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadOLTs();
  }, []);

  const loadOLTs = async () => {
    try {
      const data = await getOLTs();
      setOlts(data);
    } catch (error) {
      console.error('Error cargando OLTs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectOLT = (oltId) => {
    navigate(`/olt/${oltId}/management`);
  };

  return (
    <div className="onu-admin-container">
      <h1>Administración de ONUs</h1>
      <p className="subtitle">Seleccione una OLT para gestionar sus ONUs</p>

      {loading ? (
        <div className="loading">Cargando OLTs...</div>
      ) : (
        <div className="olts-grid">
          {olts.map((olt) => (
            <div 
              key={olt.id} 
              className="olt-card"
              onClick={() => handleSelectOLT(olt.id)}
            >
              <div className="olt-card-header">
                <h3>{olt.name}</h3>
                <span className={`olt-status ${olt.enabled ? 'enabled' : 'disabled'}`}>
                  {olt.enabled ? 'Activo' : 'Inactivo'}
                </span>
              </div>
              <div className="olt-card-body">
                <p><strong>IP:</strong> {olt.ip_address}</p>
                <p><strong>Modelo:</strong> {
                  {
                    'huawei': 'Huawei MA5800',
                    'huawei_ma5600t': 'Huawei MA5600T',
                    'huawei_5608t': 'Huawei 5608T',
                    'zte': 'ZTE C320',
                    'zte_c300': 'ZTE C300',
                    'zte_c600': 'ZTE C600'
                  }[olt.vendor] || olt.vendor
                }</p>
                <div className="olt-card-footer">
                  <button className="btn-select">
                    Gestionar ONUs →
                  </button>
                </div>
              </div>
            </div>
          ))}

          {olts.length === 0 && (
            <div className="empty-state">
              <p>No hay OLTs registradas</p>
              <button onClick={() => navigate('/olts')}>
                Ir a crear OLT
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
